<lib-modal
  [closeLabel]="'general.close' | translate"
  [visible]="visible()"
  [title]="'modules.form.testdatenblaetter.dialog.title' | translate"
  [contentTemplate]="resolvedContentTemplate ?? undefined"
  [showButtons]="false"
  (cancel)="onCancel()"
  (visibleChange)="visible.set($event)"
></lib-modal>

<ng-template #embedContent>
  <div class="ted">
    <p class="ted__subtitle" data-testid="tdb-dialog-subtitle">
      {{ 'modules.form.testdatenblaetter.dialog.subtitle' | translate: { count: selectedCount() } }}
    </p>

    <div class="ted__search">
      <mat-icon class="ted__search-icon" aria-hidden="true">search</mat-icon>
      <input
        class="ted__search-input"
        data-testid="tdb-dialog-search"
        [value]="searchTerm()"
        [placeholder]="'modules.form.testdatenblaetter.dialog.searchPlaceholder' | translate"
        [attr.aria-label]="'modules.form.testdatenblaetter.dialog.searchPlaceholder' | translate"
        (input)="onSearch($event)"
      />
    </div>

    @if (loading()) {
      <div class="ted__loading">
        <mat-spinner diameter="28" />
      </div>
    } @else if (error()) {
      <p class="ted__error" role="alert">{{ 'modules.form.testdatenblaetter.dialog.loadError' | translate }}</p>
    } @else if (filtered().length === 0) {
      <p class="ted__empty">{{ 'modules.form.testdatenblaetter.dialog.empty' | translate }}</p>
    } @else {
      <ul class="ted__list">
        @for (sheet of filtered(); track sheet.id) {
          <li
            class="ted__item"
            [class.ted__item--on]="isSelected(sheet.id)"
            [attr.data-testid]="'tdb-dialog-row-' + sheet.id"
          >
            <mat-checkbox
              [checked]="isSelected(sheet.id)"
              (change)="toggle(sheet.id)"
              [attr.aria-label]="('modules.form.testdatenblaetter.dialog.selectAria' | translate) + ' ' + sheet.name"
            >
              <span class="ted__row">
                <span class="ted__tile" aria-hidden="true"><mat-icon>grid_on</mat-icon></span>
                <code class="ted__id">{{ sheet.key }}</code>
                <span class="ted__text">
                  <span class="ted__name">{{ sheet.name }}</span>
                  <span class="ted__meta">
                    {{
                      'modules.form.testdatenblaetter.dialog.metaVars'
                        | translate: { vars: sheet.spalten.length, cols: sheet.spalten.join(', ') }
                    }}
                  </span>
                </span>
                <span class="ted__rows">
                  {{ 'modules.form.testdatenblaetter.dialog.rows' | translate: { count: sheet.zeilen.length } }}
                </span>
              </span>
            </mat-checkbox>
          </li>
        }
      </ul>
    }

    <div class="ted__footer">
      <button
        mat-stroked-button
        type="button"
        class="ted__footer-btn"
        data-testid="tdb-dialog-cancel"
        (click)="onCancel()"
      >
        {{ 'modules.form.testdatenblaetter.dialog.cancel' | translate }}
      </button>
      <button
        mat-stroked-button
        type="button"
        class="ted__footer-btn"
        data-testid="tdb-dialog-create-new"
        (click)="onCreateNew()"
      >
        <mat-icon aria-hidden="true">add</mat-icon>
        {{ 'modules.form.testdatenblaetter.dialog.createNew' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="ted__footer-btn ted__footer-btn--primary"
        data-testid="tdb-dialog-apply"
        [disabled]="!canApply()"
        (click)="onApply()"
      >
        <mat-icon aria-hidden="true">add</mat-icon>
        @if (selectedCount() > 0) {
          {{ 'modules.form.testdatenblaetter.dialog.applyN' | translate: { count: selectedCount() } }}
        } @else {
          {{ 'modules.form.testdatenblaetter.dialog.apply' | translate }}
        }
      </button>
    </div>
  </div>
</ng-template>
